import { useState } from 'react';
import { briefing, categories } from '@/mocks/gossip';
import SectionHeading from './SectionHeading';
import HotList from './HotList';

export default function NewsFeed() {
  const [active, setActive] = useState('全部');
  const [openId, setOpenId] = useState<string | null>(null);
  const list = active === '全部' ? briefing : briefing.filter((n) => n.category === active);

  return (
    <section id="gusu" className="bg-background-100/60 scroll-mt-24">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            kicker="今日瓜速递"
            title="今早刚出锅的瓜，热乎的都在这里"
            desc="晨间瓜速递按题材实时更新，头条瓜、首发猛料一网打尽，几分钟就能追完今日进度。"
          />
          <span className="mb-9 hidden items-center gap-1.5 text-xs text-foreground-500 md:flex">
            <span className="inline-block h-2 w-2 animate-pulse rounded-full bg-accent-500" />
            实时滚播 · 更新于今晨
          </span>
        </div>

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <div className="mb-7 flex flex-wrap gap-2">
              {categories.map((c) => {
                const isActive = active === c.key;
                return (
                  <button
                    key={c.key}
                    type="button"
                    onClick={() => {
                      setActive(c.key);
                      setOpenId(null);
                    }}
                    className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                      isActive
                        ? 'bg-primary-500 text-background-50'
                        : 'bg-background-50 text-foreground-700 ring-1 ring-background-200 hover:bg-secondary-100 hover:ring-background-300'
                    }`}
                  >
                    <i className={`${c.icon} h-4 w-4`} />
                    {c.key}
                    <span
                      className={`ml-0.5 rounded-full px-1.5 py-0.5 text-[10px] font-semibold ${
                        isActive ? 'bg-background-50/25 text-background-50' : 'bg-secondary-100 text-foreground-600'
                      }`}
                    >
                      {c.key === '全部' ? briefing.length : briefing.filter((n) => n.category === c.key).length}
                    </span>
                  </button>
                );
              })}
            </div>

            {list.length === 0 ? (
              <p className="rounded-2xl border border-dashed border-background-300 bg-background-50 p-10 text-center text-sm text-foreground-600">
                该题材今日暂无速递，去其他题材逛逛吧。
              </p>
            ) : (
              <ol className="relative space-y-5">
                {list.map((n) => {
                  const isOpen = openId === n.id;
                  return (
                    <li key={n.id} className="relative flex flex-col gap-3 pl-6 before:absolute before:left-0 before:top-2.5 before:h-2.5 before:w-2.5 before:rounded-full before:bg-accent-500 md:pl-8">
                      <article
                        className={`group flex-1 rounded-2xl border bg-background-50 transition-colors ${
                          isOpen
                            ? 'border-primary-300 ring-1 ring-primary-200'
                            : 'border-background-200 hover:border-primary-200'
                        }`}
                      >
                        <div className="flex flex-col gap-3 p-4 md:p-5">
                          <div className="flex flex-wrap items-center gap-2">
                            <span className="font-mono text-sm font-bold text-primary-600">{n.time}</span>
                            <span className="inline-flex items-center rounded-md bg-accent-100 px-2 py-0.5 text-[11px] font-semibold text-accent-900">
                              {n.category}
                            </span>
                            {n.tag ? (
                              <span className="inline-flex items-center rounded-md bg-primary-100 px-2 py-0.5 text-[11px] font-semibold text-primary-700">
                                <i className="ri-flashlight-fill mr-0.5 h-3 w-3" />
                                {n.tag}
                              </span>
                            ) : null}
                            {n.fresh ? (
                              <span className="inline-flex items-center gap-1 text-[11px] font-medium text-accent-700">
                                <span className="inline-block h-1.5 w-1.5 rounded-full bg-accent-500" />
                                新出锅
                              </span>
                            ) : null}
                            <span className="ml-auto hidden items-center gap-1.5 text-xs text-foreground-500 sm:flex">
                              <i className="ri-fire-line h-3.5 w-3.5 text-accent-600" />
                              {n.heat} 热度
                            </span>
                          </div>
                          <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 md:text-lg">
                            {n.title}
                          </h3>
                          <p className="text-sm leading-relaxed text-foreground-600">{n.excerpt}</p>
                          <div className="flex flex-wrap items-center gap-3">
                            <span className="flex items-center gap-1 text-[11px] text-foreground-400">
                              <i className="ri-article-line h-3.5 w-3.5" />
                              信源 · {n.source}
                            </span>
                            <button
                              type="button"
                              onClick={() => setOpenId(isOpen ? null : n.id)}
                              className="ml-auto inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-secondary-100 px-3 py-1.5 text-xs font-semibold text-secondary-900 transition-colors hover:bg-secondary-200"
                            >
                              {isOpen ? '收起' : '展开速览'}
                              <i className={`${isOpen ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} h-4 w-4`} />
                            </button>
                          </div>
                          {isOpen ? (
                            <p className="mt-1 rounded-xl bg-background-100 p-4 text-sm leading-relaxed text-foreground-700">
                              早报补课：{n.excerpt} 相关话题正在各社交平台持续升温，编辑部将持续跟进事件后续，并在次日早报「瓜田复盘」板块给出完整梳理与可核实信源。
                            </p>
                          ) : null}
                        </div>
                      </article>
                    </li>
                  );
                })}
              </ol>
            )}
          </div>

          <aside id="bang" className="scroll-mt-24 lg:col-span-1">
            <div className="sticky top-24 space-y-6">
              <HotList />
              <div className="rounded-2xl border border-background-200 bg-background-50 p-5 md:p-6">
                <div className="flex items-start gap-3">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-accent-100 text-accent-800">
                    <i className="ri-information-line h-5 w-5" />
                  </span>
                  <div>
                    <h4 className="font-heading text-sm font-bold text-foreground-950">什么是吃瓜今日早报？</h4>
                    <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">
                      一份每个清晨更新的娱乐瓜速递，帮你用几分钟掌握当日头条瓜与首发猛料。点击「订阅早报」即可每日自动送达邮箱。
                    </p>
                    <a
                      href="#subscribe"
                      className="mt-3 inline-flex items-center gap-1 text-xs font-semibold text-primary-600 hover:text-primary-700"
                    >
                      立即免费订阅 <i className="ri-arrow-right-line h-3.5 w-3.5" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}